// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Facebook = function Facebook(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M10.6 2.729v1.846H9.5a1.027 1.027 0 0 0-.811.252 1.161 1.161 0 0 0-.21.755V6.9h2.049l-.273 2.07h-1.77v5.308H6.346V8.974H4.562V6.9h1.784V5.379a2.706 2.706 0 0 1 .727-2.018 2.638 2.638 0 0 1 1.937-.716 11.581 11.581 0 0 1 1.594.084z' })
  );
};

Facebook.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Facebook;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Facebook.js
// module id = 1028
// module chunks = 1